































































import BackButton from "@/components/BackButton.vue";
import DataPanels from "@/components/DataPanels.vue";
import Keywords from "@/components/Keywords.vue";
import PairRow from "@/components/PairRow.vue";
import ReloadButton from "@/components/ReloadButton.vue";
import StatusChip from "@/components/StatusChip.vue";
import Worker from "@/components/Worker.vue";
import range from "lodash/range";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import PosterUser from "../mixins/poster-user";
import { Poster, isModifiablePoster, needsUpload } from "../models/poster";

const POSTER_FIELDS: [keyof Poster, string][] = [
  ["observaciones", "Observaciones"],
  // ['resumen', 'Resumen'],
  ["palabras_claves", "Palabras clave"],
  ["introduccion", "Introducción"],
  // ['problema_inv', 'Problema de Investigación'],
  // ['ref_teorico', 'Referente Teórico'],
  ["objetivo_general", "Objetivo general"],
  // ['objetivo_especifico', 'Objetivo específico'],
  ["metodologia", "Metodología"],
  ["resultados", "Resultados"],
  ["conclusiones", "Conclusiones"],
  // ['referencias', 'Referencias'],
];

export default PosterUser.extend({
  components: {
    StatusChip,
    DataPanels,
    Keywords,
    BackButton,
    ReloadButton,
    Worker,
    PairRow,
  },

  data() {
    const fieldCount = Object.keys(POSTER_FIELDS).length;
    const expanded = range(fieldCount);
    return {
      posterType: "user",
      expanded,
    };
  },

  computed: {
    ...mapGetters("shared", ["featureEnabled"]),
    fields() {
      const poster: Poster | null = (this && this.poster) || null;
      const d = POSTER_FIELDS.map(([key, header]) => {
        const data = {
          key,
          header,
          content: poster && poster[key],
        };
        if (key === "observaciones") {
          data["headerClass"] = "c-header-obs";
        }
        return data;
      });

      console.log(poster);

      return d;
    },

    keywordsArray() {
      return this?.poster?.palabras_claves?.split(",");
    },

    mayUpdate() {
      return (
        this.featureEnabled("actualizar_datos") &&
        this.poster &&
        (isModifiablePoster(this.poster) || needsUpload(this.poster))
      );
    },

    tieneObservaciones() {
      const ob = this.poster?.observaciones;
      return ob && ob.length > 0;
    },
  },

  methods: {
    update() {
      const { poster } = this;
      if (!poster) {
        return;
      }

      const id = poster.id_poster;
      if (isModifiablePoster(poster)) {
        this.$router.push(`/registroposter/${id}`);
      } else if (needsUpload(poster)) {
        this.$router.push(`/usuario#u${id}`);
      }
    },

    download() {
      if (!this.poster) {
        return;
      }

      this.$store
        .dispatch("poster/downloadPosterPdf", this.poster)
        .catch(() => {
          Swal.fire(
            "Error",
            "No fue posible general el documento PDF",
            "error"
          );
        });
    },
  },

  async created() {
    await this.sync();
    if (!this.poster) {
      this.$router.replace("/usuario");
    }
  },
});
